"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherToJSON = exports.VoucherFromJSONTyped = exports.VoucherFromJSON = exports.instanceOfVoucher = void 0;
var runtime_1 = require("../runtime");
var EntityMetadata_1 = require("./EntityMetadata");
var VoucherOwner_1 = require("./VoucherOwner");
var VoucherReward_1 = require("./VoucherReward");
var VoucherRewardType_1 = require("./VoucherRewardType");
var VoucherStatus_1 = require("./VoucherStatus");
/**
 * Check if a given object implements the Voucher interface.
 */
function instanceOfVoucher(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "giveawayId" in value;
    isInstance = isInstance && "expiresAt" in value;
    isInstance = isInstance && "claimedAt" in value;
    isInstance = isInstance && "owner" in value;
    isInstance = isInstance && "reward" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "metadata" in value;
    return isInstance;
}
exports.instanceOfVoucher = instanceOfVoucher;
function VoucherFromJSON(json) {
    return VoucherFromJSONTyped(json, false);
}
exports.VoucherFromJSON = VoucherFromJSON;
function VoucherFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'giveawayId': json['giveawayId'],
        'expiresAt': (new Date(json['expiresAt'])),
        'claimedAt': (json['claimedAt'] === null ? null : new Date(json['claimedAt'])),
        'owner': (0, VoucherOwner_1.VoucherOwnerFromJSON)(json['owner']),
        'reward': (0, VoucherReward_1.VoucherRewardFromJSON)(json['reward']),
        'status': (0, VoucherStatus_1.VoucherStatusFromJSON)(json['status']),
        'metadata': (0, EntityMetadata_1.EntityMetadataFromJSON)(json['metadata']),
        'rewardType': !(0, runtime_1.exists)(json, 'rewardType') ? undefined : (0, VoucherRewardType_1.VoucherRewardTypeFromJSON)(json['rewardType']),
    };
}
exports.VoucherFromJSONTyped = VoucherFromJSONTyped;
function VoucherToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'giveawayId': value.giveawayId,
        'expiresAt': (value.expiresAt.toISOString()),
        'claimedAt': (value.claimedAt === null ? null : value.claimedAt.toISOString()),
        'owner': (0, VoucherOwner_1.VoucherOwnerToJSON)(value.owner),
        'reward': (0, VoucherReward_1.VoucherRewardToJSON)(value.reward),
        'status': (0, VoucherStatus_1.VoucherStatusToJSON)(value.status),
        'metadata': (0, EntityMetadata_1.EntityMetadataToJSON)(value.metadata),
        'rewardType': (0, VoucherRewardType_1.VoucherRewardTypeToJSON)(value.rewardType),
    };
}
exports.VoucherToJSON = VoucherToJSON;
